import IconBase from "../IconBase";

const SpotifyIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M5.46155 18.4061C9.33137 17.0664 13.432 17.6208 17 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M3.15384 12.8C5.25754 12.2308 7.51423 11.9231 9.84742 11.9231C13.7106 11.9231 17.3442 12.7692 20.4615 14.2308"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M2 6.575C4.60559 5.55385 7.47552 5 10.4965 5C15.0469 5 19.2762 6.28077 22.7692 8.46154"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default SpotifyIcon;
